export default __webpack_public_path__ + "static/media/type-icon.a99bbc71.svg";